<template>
  <div>
    <Form :model="resourceModel" :rules="ruleValidate" ref="resourceModel" label-position="top" autocomplete="on"
      name="oohforce-medium-add" id="oohforce-medium-add">
      <Row :gutter="8" class="m-b-10">
        <i-col span="12">
          <FormItem label="交易资产" prop="assetId">
            <Select v-model="resourceModel.assetId" filterable @on-change="onChangeAsset" size="small"
              placeholder="请选择所属资产（可通过关键字搜索）">
              <Option v-for="item in assetArray" :value="item.id" :key="'asset_' + item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </i-col>
        <i-col span="12">
          <FormItem label="站点" prop="stationId">
            <Select v-model="resourceModel.stationId" @on-change="handleChangeStation" filterable size="small"
              placeholder="请选择所属站点（可通过关键字搜索）">
              <Option v-for="item in stationArray" :value="item.id" :key="'staiton_' + item.id">
                {{ rimAssetIds.length > 1 ? `${item.name} - ${item.assetName}` : item.name }}</Option>
            </Select>
          </FormItem>
        </i-col>
      </Row>
      <Row :gutter="8" class="m-b-10">
        <i-col span="12">
          <FormItem label="编号" prop="code">
            <Input v-model="resourceModel.code" size="small" placeholder="请填写编号(主题产品请输入产品名称）" />
          </FormItem>
        </i-col>
        <i-col span="12">
          <FormItem label="所属类型" prop="resourcetypeId">
            <Select v-model="resourceModel.resourcetypeId" filterable size="small" placeholder="请选择所属类型（可通过关键字搜索）">
              <Option v-for="item in resourceTypeArray" :value="item.id" :key="'res_' + item.id">{{ item.name
                }}
              </Option>
            </Select>
          </FormItem>
        </i-col>
      </Row>
      <Row :gutter="8" class="m-b-10">
        <i-col span="24">
          <FormItem label="所属项目" prop="projectId">
            <Select v-model="resourceModel.projectId" filterable size="small" placeholder="请选择所属项目（可通过关键字搜索）">
              <Option v-for="item in projectArray" :value="item.id" :key="'project_' + item.id">{{ item.name
                }}
              </Option>
            </Select>
          </FormItem>
        </i-col>
      </Row>
      <!-- <Row :gutter="8" class="m-b-10">
        <i-col span="12">
          <FormItem label="一级类型" prop="resourceBigtypeId">
            <Select v-model="resourceModel.resourceBigtypeId" size="small" placeholder="请选择一级类型"
              @on-change="handleChangeType">
              <Option v-for="item in resourceTypeArray" :value="item.id" :key="'resType_' + item.id">{{ item.name }}
              </Option>
            </Select>
          </FormItem>
        </i-col>
        <i-col span="12">
          <FormItem label="二级类型" prop="resourcetypeId">
            <Select v-model="resourceModel.resourcetypeId" filterable size="small" placeholder="请选择二级类型（可通过关键字搜索）">
              <Option v-for="item in resChildTypeArray" :value="item.id" :key="'resChildType_' + item.id">{{ item.name
                }}
              </Option>
            </Select>
          </FormItem>
        </i-col>
      </Row> -->
      <!-- <Row :gutter="8" class="m-b-10">
        <i-col span="12">
          <FormItem label="状态（来自所选设备状态）">
            <RadioGroup v-model="resourceModel.enabled">
              <Radio :disabled="true" :label="1">可用</Radio>
              <Radio :disabled="true" :label="0">不可用</Radio>
              <Radio :disabled="true" :label="-1">冻结</Radio>
            </RadioGroup>
          </FormItem>
        </i-col>
      </Row> -->
      <FormItem label="备注">
        <Input v-model="resourceModel.remark" type="textarea" style="width: 100%;" placeholder="变更备注（非必填）" />
      </FormItem>
    </Form>
  </div>
</template>

<script>
// import { getDevicePage } from '@/api/product/device'
// import { saveResource, updateResource } from '@/api/product/resource'
/** new api */
import { getRimStationByAssetIds } from '@/api/rim/station'
import { deviceResMixins } from '../mixins/index'
// import { getPublisherDevicePage, getDevice } from '@/api/rim/device'
import { submitCom } from '@/api/product/resource'

export default {
  props: {
    operate: {
      type: Number,
      default: 1
    },
    assetArray: {
      type: Array,
      required: true
    },
    resourceTypeArray: {
      type: Array,
      required: true
    },
    projectArray: [Array],
    onSuccess: Function
  },
  mixins: [deviceResMixins],
  data () {
    return {
      resourceModel: {
        id: null,
        assetId: null,
        stationId: null,
        deviceId: null,
        code: '',
        resourceBigtypeId: 4, // 组合资源
        resourcetypeId: null,
        makewidth: 0,
        makeheight: 0,
        finalwidth: 0,
        finalheight: 0,
        side: 1,
        area: 0,
        enabled: 1,
        fix: 0,
        stock: 1,
        standard: 1,
        floor: null,
        position: null,
        level: null,
        // open: 0,
        projectId: null,
        remark: ''
        // packageId: null
        // makeMaterial: null,
        // makeMaterialName: '',
        // makeProcess: null
      },
      rimAssetIds: [],
      deviceQuery: {
        pageNumber: 1,
        pageSize: 1000,
        keyword: '',
        assetId: null,
        devicemodel: null,
        stationId: null,
        enabled: null
      },
      stationArray: [],
      deviceList: [],
      // resourceTypeArray: [],
      // resChildTypeArray: [], // 二级类别
      makeMaterialArray: [],
      ruleValidate: {
        assetId: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ],
        stationId: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ],
        code: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        resourcetypeId: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ],
        projectId: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    assetId () {
      return this.$store.state.deviceManage.selectedAssetId
    },
    curResInfo () {
      return this.$store.state.deviceManage.curResInfo
    },
    // levelArray () {
    //   return this.$store.state.deviceManage.levelArray
    // },
    curDeviceInfo () {
      return this.$store.state.deviceManage.curDeviceInfo
    }
  },
  methods: {
    onChangeAsset () {
      this.rimAssetIds = [this.resourceModel.assetId]
      const rimAsset = this.assetArray.find(x => x.id === this.resourceModel.assetId)

      if (rimAsset) {
        this.rimAssetIds = this.assemblyRimAssetIds(rimAsset.rimAssetIds)
      }

      getRimStationByAssetIds({ assetIds: JSON.stringify(this.rimAssetIds) }).then((res) => {
        this.stationArray = res
        // this.$store.commit('set_station_array', this.stationArray)
        // if (this.operate === 3) {
        //   const station = this.stationArray.find(x => x.id === this.resourceModel.stationId)
        //   this.resourceModel.level = station.level ? station.level : -1
        // }
      })
    },
    handleChangeStation () {
      this.deviceQuery.stationId = this.resourceModel.stationId
      if (this.operate === 1) {
        const station = this.stationArray.find(x => x.id === this.resourceModel.stationId)
        this.resourceModel.level = station.level ? station.level : -1
      }
    },

    // handleChangeType () {
    //   this.resChildTypeArray = this.resourceTypeArray.find(x => x.id === this.resourceModel.resourceBigtypeId).children || []
    // },
    handleSubmit () {
      this.$refs.resourceModel.validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '操作提示',
            content: '确认信息无误，并提交？',
            onOk: () => {
              this.resourceModel.standard = Boolean(this.resourceModel.standard)
              this.resourceModel.level = this.resourceModel.level || -1
              // if (this.operate === 1) {
              // this.resourceModel.assetId = this.stationArray.find(x => x.id === this.resourceModel.stationId).assetId
              // }
              submitCom(JSON.stringify(this.resourceModel)).then(res => {
                if (res && res.errcode === 0) {
                  this.onSuccess()
                  this.$Notice.success({ desc: '操作成功' })
                }
              })
            }
          })
        } else {
          this.$Notice.error({ desc: '请正确填写信息' })
        }
      })
    }
  },
  watch: {
    operate: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val === 2) { // 编辑
          Object.keys(this.resourceModel).forEach(key => {
            this.resourceModel[key] = this.curResInfo[key]
          })
          this.resourceModel.standard = Number(this.curResInfo.standard)
          // this.getStationArray()
          this.handleChangeStation()
        } else {
          // this.getStationArray()
          this.resourceModel.id = null
        }
        this.onChangeAsset()
        // this.handleChangeType()
      }
    }
  }
}
</script>
